/* The Hamper Co – personalisation picker for snippets/thc-personalise.liquid. Loaded on every page so it also works in quick-add popups. */
    (function () {
      if (customElements.get('thc-personalise')) return;

      var MAX_BYTES = 10 * 1024 * 1024;

      class ThcPersonalise extends HTMLElement {
        connectedCallback() {
          var self = this;
          if (this._thpInit) return;
          this._thpInit = true;

          // In a quick-add popup the form id can clash with the page's own product form, so give it a unique id
          var dlg = this.closest('dialog');
          if (dlg) {
            var oldId = this.dataset.form;
            var dlgForm = dlg.querySelector('form[id="' + oldId + '"]');
            if (dlgForm) {
              var newId = oldId + '-qa';
              dlgForm.setAttribute('id', newId);
              dlg.querySelectorAll('[form="' + oldId + '"]').forEach(function (el) { el.setAttribute('form', newId); });
              this.dataset.form = newId;
            }
          }
          this.v = { none: this.dataset.none, name: this.dataset.name, logo: this.dataset.logo, hamper: this.dataset.hamper, hamperlogo: this.dataset.hamper };
          this.min = parseInt(this.dataset.min, 10) || 5;
          this.radios = Array.prototype.slice.call(this.querySelectorAll('.thp__opts input[type="radio"]'));
          this.fileInput = this.querySelector('[data-thp-logo] input');
          this.nameInput = this.querySelector('[data-thp-name] input');
          this.typeInput = this.querySelector('[data-thp-type]');
          this.fileError = this.querySelector('[data-thp-file-error]');
          this.qtyError = this.querySelector('[data-thp-qty-error]');

          // The logo-on-box option shows the gift box picture
          var boxImg = this.querySelector('img[data-src-box]');
          if (boxImg) boxImg.src = boxImg.dataset.srcBox;

          // Start from whichever variant is selected (e.g. a shared link to the hamper upgrade)
          var cur = this.currentValue();
          this.choice = 'none';
          ['none', 'name', 'logo', 'hamper'].forEach(function (k) { if (self.v[k] && self.v[k] === cur) self.choice = k; });
          this.radios.forEach(function (r) { r.checked = r.value === self.choice; });

          this.radios.forEach(function (r) {
            r.addEventListener('change', function () { if (r.checked) { self.choice = r.value; self.apply(true); } });
          });
          this.fileInput.addEventListener('change', function () { self.checkFile(); });

          // Jump to the complimentary gift note box
          var noteLink = this.querySelector('[data-thp-giftnote]');
          if (noteLink) noteLink.addEventListener('click', function (e) {
            e.preventDefault();
            var note = self.scope().querySelector('product-custom-property-component [name*="complimentary" i], product-custom-property-component [name*="gift note" i], product-custom-property-component [name*="message" i]');
            if (!note) return;
            note.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(function () { note.focus({ preventScroll: true }); }, 400);
          });

          // Re-check the minimum whenever quantity changes or someone tries to add to basket
          var onQty = function (e) {
            var t = e.target;
            if (t && t.name === 'quantity') self.checkQty(false);
          };
          document.addEventListener('input', onQty, true);
          document.addEventListener('change', onQty, true);
          document.addEventListener('click', function (e) {
            var btn = e.target.closest && e.target.closest('button');
            if (!btn) return;
            var form = self.form();
            if (!form) return;
            var isSubmit = btn.type === 'submit' && (btn.form === form || btn.getAttribute('form') === form.id);
            if (isSubmit) self.checkQty(true);
            else if (btn.closest('quantity-selector-component')) setTimeout(function () { self.checkQty(false); }, 0);
          }, true);

          this.apply(false);
        }

        scope() { return this.closest('dialog') || this.closest('.shopify-section') || document; }
        form() { return this.scope().querySelector('form[id="' + this.dataset.form + '"]') || document.getElementById(this.dataset.form); }
        qtyInput() { var f = this.form(); return f ? f.elements['quantity'] : null; }
        isLogo() { return this.choice === 'logo' || this.choice === 'hamperlogo'; }
        // Only logo hampers have a minimum (liners are printed in batches); logo gift boxes don't
        needsMin() { return this.choice === 'hamperlogo' || (this.choice === 'logo' && this.dataset.basket === 'true'); }

        picker() {
          return this.scope().querySelector('variant-picker');
        }

        optionInputs() {
          var vp = this.picker();
          if (!vp) return [];
          var vals = [this.v.none, this.v.name, this.v.logo, this.v.hamper].filter(Boolean);
          return Array.prototype.filter.call(vp.querySelectorAll('input[type="radio"]'), function (i) { return vals.indexOf(i.value) > -1; });
        }

        currentValue() {
          var checked = this.optionInputs().filter(function (i) { return i.checked; })[0];
          if (checked) return checked.value;
          var vals = [this.v.none, this.v.name, this.v.logo, this.v.hamper];
          var vp = this.picker();
          var sel = vp && Array.prototype.find.call(vp.querySelectorAll('select'), function (s) { return vals.indexOf(s.value) > -1; });
          return sel ? sel.value : '';
        }

        selectVariant() {
          var target = this.v[this.choice];
          if (!target || target === this.currentValue()) return;
          var radio = this.optionInputs().filter(function (i) { return i.value === target; })[0];
          if (radio) { radio.click(); return; }
          var vp = this.picker();
          var sel = vp && Array.prototype.find.call(vp.querySelectorAll('select'), function (s) {
            return Array.prototype.some.call(s.options, function (o) { return o.value === target; });
          });
          if (sel) { sel.value = target; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        }

        checkFile() {
          var f = this.fileInput.files && this.fileInput.files[0];
          var msg = '';
          if (f && f.size > MAX_BYTES) msg = 'That file is over 10MB. Please upload a smaller version, or email it to natalie@thehamperco.co.uk.';
          this.fileInput.setCustomValidity(msg);
          this.fileError.textContent = msg;
          this.fileError.hidden = !msg;
        }

        checkQty(report) {
          var q = this.qtyInput();
          if (!q) return true;
          var n = parseInt(q.value, 10) || 0;
          var bad = this.needsMin() && n < this.min;
          var msg = bad ? 'Logo hampers have a minimum order of ' + this.min + '. Please set the quantity to ' + this.min + ' or more.' : '';
          q.setCustomValidity(msg);
          this.qtyError.textContent = msg;
          this.qtyError.hidden = !bad;
          if (bad && report) q.reportValidity();
          return !bad;
        }

        apply(changeVariant) {
          var c = this.choice;
          var logo = this.isLogo();
          var name = c === 'name';
          var on = c !== 'none';

          this.querySelector('[data-thp-logo]').hidden = !logo;
          this.querySelector('[data-thp-name]').hidden = !name;

          // Only the active field is submitted and required
          this.fileInput.disabled = !logo;
          this.fileInput.required = logo;
          this.nameInput.disabled = !name;
          this.nameInput.required = name;
          this.typeInput.disabled = !on;
          this.typeInput.value = c === 'name' ? 'Name (gold foil)'
            : c === 'logo' ? (this.v.name || this.v.hamper ? 'Logo on gift box' : 'Logo on hamper basket')
            : c === 'hamperlogo' ? 'Logo – 14" black wicker hamper'
            : c === 'hamper' ? '14" black wicker hamper – Hamper Co branding (no logo)' : '';

          // Bump quantity up to the logo minimum
          var q = this.qtyInput();
          if (this.needsMin() && q && (parseInt(q.value, 10) || 0) < this.min) {
            q.value = this.min;
            q.dispatchEvent(new Event('input', { bubbles: true }));
            q.dispatchEvent(new Event('change', { bubbles: true }));
          }
          this.checkQty(false);
          this.querySelector('[data-thp-min-note]').hidden = !this.needsMin();

          // Retire the old foil-wording box so it can't send an empty or conflicting value
          document.querySelectorAll('[name="properties[gift box customised]"]').forEach(function (i) { i.disabled = true; });

          // Express checkout buttons skip line item properties, so hide them while personalising
          this.scope().querySelectorAll('[ref="acceleratedCheckoutButtonContainer"], .shopify-payment-button').forEach(function (el) {
            el.style.display = on ? 'none' : '';
          });

          if (changeVariant) this.selectVariant();
        }
      }

      customElements.define('thc-personalise', ThcPersonalise);
    })();
